module.exports = __webpack_public_path__ + "img/安全监测-bg.9b781c06.jpg";